import { render, staticRenderFns } from "./WeekDaySelect.vue?vue&type=template&id=6bbf9896&scoped=true"
import script from "./WeekDaySelect.vue?vue&type=script&lang=js"
export * from "./WeekDaySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf9896",
  null
  
)

export default component.exports